import {
  ExpoRouterDemoBackButton,
  ExpoRouterDemoScreen,
  ExpoRouterDemoTitle,
} from '../../../components';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return (
    <ExpoRouterDemoScreen>
      <ExpoRouterDemoTitle>Favorites</ExpoRouterDemoTitle>
      <ExpoRouterDemoBackButton />
    </ExpoRouterDemoScreen>
  );
}
